﻿export class Informes {
    Id: number;
    ID_TIPO_INFORME: number;
    ID_GRUPO: number;
    ANO: number;
    MES: number;
    DESCRIPCION: string;
    HASH: string;
    FILENAME: string;
    NOMBRE_CLIENTE: string;
    NOMBRE_GRUPO: string;
    TIPO_INFORME: string;
    ID_CLIENTE: number;
    ID_TIPO_NOMBRE: number;
    constructor() {
    }
}

export class InformesSearch {
    ID_CLIENTE: number;
    ID_TIPO_INFORME: number;
    ID_GRUPO: number;
    ANO: number;
    MES: number;
    constructor() { }
}

export class InformesUpload {
    ID: number; // para actualizar unicamente
    ID_TIPO_INFORME: number;
    ID_GRUPO: number;
    ANO: number;
    MES: number;
    NOMBRE_MES: string;
    NOMBRE_CLIENTE: string;
    NOMBRE_GRUPO: string;
    NOMBRE_INFORME: string;
    GUID: string;
    FILENAME: string;
    OVERWRITE: boolean;
}

export class InformeConsultas {
  constructor(
    public CANTIDAD_AGRUPADA: InformeAgrupacionConsultas[] = [],
    public AGRUPACION_ALL: InformeAgrupacionConsultas[] = [],
    public INFORME: InformeContabilidadConsultas[] = [],
  ) { }
}

export class InformeAgrupacionConsultas {
  constructor(
    public name: string = '',
    public value: number = 0
  ) { }
}

export class InformeContabilidadConsultas {
  constructor(
    public CLIENTE: string = '',
    public SERIE: string = '',
    public ID_PRESTAMO: number = 0,
    public FECHA_ALTA: Date = new Date(),
    public SOLICITANTE: string = '',
    public FECHA_FIN: Date = new Date(),
    public FECHA_LIMITE: Date = new Date(),
    public ESTADO: string = '',
    public SITUACION: string = '',
    public CONTENIDOS: InformeContabilidadConsultasContenido[],
    public LOCALIZADOS: number = 0,
    public BUSQUEDAS: number = 0,
    public IMAGENES: number = 0
  ) { }

}

export class InformeContabilidadConsultasContenido {
  constructor(
    public ID_CONTENIDO: number = 0,
    public ESTADO: string = '',
    public SITUACION: string = '',
    public CONTABILIDAD: InformeContabilidadConsultasCuentaContenido[],
  ) { }
}

export class InformeContabilidadConsultasCuentaContenido {
  constructor(
    public CANTIDAD: number = 0,
    public DESCRIPCION: string = ''
  ) { }
}

export class FiltroInformeContabilidadConsultas {
  constructor(
    public CLIENTE: string[] = [],
    public GRUPO: string = '',
    public FECHA_ALTA_INICIO: Date = new Date(),
    public FECHA_ALTA_FINAL: Date = new Date(),
    public OperadorInicial: number = 0,
    public OperadorFinal: number = 0,
    public SOLICITANTE: string = ''
  ) {
    const Operadores = {
      mayorigualque: 0,
      menorigualque: 1,
      entre: 2
    };
   }
}


